import { makeObservable, observable, flow, action, computed } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import { toast } from "sonner";

import CreateControlSchema from "@/areas/controls/schemas/CreateControlSchema";

export default class CreateControlStore {
  visible = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canDelete: computed,
    });

    this.parentStore = parentStore;
  }

  get canDelete() {
    return this.parentStore.controlPermissionStore.isCoordinator;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  *save(data, options) {
    const parseResult = CreateControlSchema.safeParse(data);
    if (!parseResult.success) {
      return parseResult;
    }

    try {
      const response = yield api.post(ApiRoutes.forControls(), data);
      this.visible = false;
      toast.success("Control created successfully");
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while creating control", {
        description: e.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    }
  }
}
